import { useEffect, useState } from 'react';

const usePresignedUrls = (
    items: Array<{ id: string; imageUrl: string }>,
    validateAwsURL: (url: string) => Promise<string | null>
): Record<string, string> => {
    const [imageUrls, setImageUrls] = useState<Record<string, string>>({});

    useEffect(() => {
        const fetchPresignedUrls = async () => {
            const updatedUrls: Record<string, string> = {};
            const itemsToFetch = items.filter((item) => {return !imageUrls[item.id];});

            for (const item of itemsToFetch) {
                const presignedUrl = await validateAwsURL(item.imageUrl);
                updatedUrls[item.id] = presignedUrl ?? item.imageUrl;
            }

            if (Object.keys(updatedUrls).length > 0) {
                setImageUrls((prev) => {return { ...prev, ...updatedUrls };});
            }
        };

        if (items.length > 0) {
            fetchPresignedUrls();
        }
    }, [items, validateAwsURL, imageUrls]);

    return imageUrls;
};

export default usePresignedUrls;
